import { auth, CF_BASE_URL } from "../firebase";

export const generateCoupons = async (count = 100) => {
  if (!CF_BASE_URL) {
    throw new Error("Coupon backend is not configured. Please contact support.");
  }
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error("Admin login required");
  }

  const res = await fetch(`${CF_BASE_URL}/generateCoupons`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ count }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Unable to generate coupons");
  }
  return await res.json();
};
